import { render } from "./ConsultarCuotas.vue?vue&type=template&id=4b83cf24&scoped=true"
import script from "./ConsultarCuotas.vue?vue&type=script&lang=js"
export * from "./ConsultarCuotas.vue?vue&type=script&lang=js"

import "./ConsultarCuotas.vue?vue&type=style&index=0&id=4b83cf24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b83cf24"]])

export default __exports__